'use client'
// components/Modal/Modal.jsx

import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

const Modal = ({
  isOpen,
  onClose,
  children,
  classNames = {
    modalOverlay: 'modal-overlay',
    modalContent: 'modal-content',
    closeButton: 'close-button',
  },
  closeLabel = undefined,
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const [mountNode, setMountNode] = useState(null)
  const hasCloseButton = !!onClose || !!closeLabel
  useEffect(() => {
    setMountNode(document.body)
  }, [])

  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflowY = 'hidden'
      // Trigger visibility after component mounts
      setTimeout(() => {
        setIsVisible(true)
      }, 0)
    } else {
      setIsVisible(false)
      window.document.body.style.overflowY = 'auto'
    }
    return () => {
      window.document.body.style.overflowY = 'auto'
    }
  }, [isOpen])

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        onClose()
      }
    }
    if (isOpen) {
      window.addEventListener('keydown', handleEsc)
    }
    return () => {
      window.removeEventListener('keydown', handleEsc)
    }
  }, [isOpen, onClose])

  if (!mountNode) return null

  return ReactDOM.createPortal(
    <div
      className={`${classNames.modalOverlay} ${isVisible ? 'modal-open' : ''}`}
      role='dialog'
      aria-modal='true'
      aria-labelledby='modal-title'
      onClick={isOpen ? onClose : null}
      tabIndex={-1}
    >
      <div
        className={`${classNames.modalContent} ${
          isVisible ? 'modal-open' : ''
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
      {hasCloseButton ? (
        <ModalCloseButton
          ariaLabel={'Chiudi modal'}
          className={classNames.closeButton}
          onClick={onClose}
        >
          {closeLabel}
        </ModalCloseButton>
      ) : null}
    </div>,
    mountNode
  )
}

function ModalCloseButton({
  children,
  onClick,
  className = 'close-button',
  ariaLabel = 'Chiudi modal',
}) {
  return (
    <button
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
      >
        <path
          d='M18.864 5.63599L6.13609 18.3639'
          stroke='#FAFAFA'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M6.13599 5.63599L18.8639 18.3639'
          stroke='#FAFAFA'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </svg>
    </button>
  )
}

export default Modal
